import {Component} from '@angular/core';

/* Body only -- HelpDialogComponent supplies the dialog chrome and Okay button. */
@Component({
    selector: 'app-api-docs-help',
    templateUrl: './api-docs-help.component.html'
})
export class ApiDocsHelpComponent {
}
